module.exports = __webpack_public_path__ + "img/3fe7df3.jpg";